import { IIconProps } from '@srm/ui/types/IIconProps';
/* eslint-disable max-len */

const AiBotIcon = ({ size = 24, ...props }: IIconProps) => {
    return (
        <svg {...props} width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="aiBotIconMask" maskUnits="userSpaceOnUse" x="0" y="0" width="64" height="64">
                <rect width="64" height="64" fill="white" />
                <rect x="17" y="19" width="30" height="20" rx="9" fill="black" />
            </mask>
            <g mask="url(#aiBotIconMask)" fill="currentColor">
                <circle cx="32" cy="4.5" r="2.6" />
                <rect x="30.7" y="6.4" width="2.6" height="7" rx="1.3" />
                <rect x="11" y="13" width="42" height="32" rx="14" />
                <rect x="5" y="24" width="6" height="14" rx="3" />
                <rect x="53" y="24" width="6" height="14" rx="3" />
                <path d="M27 44 L31.5 53 L37 44 Z" />
            </g>
            <ellipse cx="25" cy="29.2" rx="2.7" ry="3.6" fill="currentColor" />
            <ellipse cx="39" cy="29.2" rx="2.7" ry="3.6" fill="currentColor" />
        </svg>
    );
};

export default AiBotIcon;
